module.exports = __webpack_public_path__ + "static/media/AD.f0070396.svg";